<template>
	<b-container fluid class="dashboard">
		<b-row class="dashContent">
			<b-col md="3">
				<div class="userProfile">
					<img src="/public/images/anonymous.jpg" class="avatar">
					<h5 class="greetings">Sugeng Rawuh,</h5>
					<h4>Kang Mimin</h4>
				</div>
				<div class="menuBar">
					<b-nav vertical class="">
						<b-nav-item to="/admin">Dashboard</b-nav-item>
						<b-nav-item to="/event_participant">Participant List</b-nav-item>
						<!-- <b-nav-item to="/maileditor">E-mail Editor</b-nav-item> -->
					</b-nav>
					<!-- <b-nav-form class="mt-2">
						<b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
						<b-button size="sm" class="my-2 my-sm-0" type="submit"><b-icon icon="search"></b-icon></b-button>
					</b-nav-form> -->
				</div>
			</b-col>
			<b-col md="9">
				<div class="m-3">
			<!-- <b-pagination-nav
				v-model="currentPage"
				:number-of-pages="maxPage"
				:base-url="'/' + resource + '/'"
				last-number
				:use-router=useRouter
				align="fill"
				limit=10
			></b-pagination-nav> -->
			<!-- <b-pagination-nav
				v-model="currentPage"
				:number-of-pages="maxPage"
				:base-url="'/' + type + '/'"
				last-number
				:use-router=useRouter
				align="fill"
				limit=10
			></b-pagination-nav> -->
			<!-- <div align="center"><span>page {{ page }} of {{ maxPage }} [showing {{itemsPerPage}} of {{totalRows}}]</span></div> -->
			<div class="news-list-nav" align="center">
				<router-link v-if="page > 1" :to="'/' + resource + '/' + (page - 1)">&lt; prev</router-link>
				<a v-else class="disabled">&lt; prev</a>
				<span> page {{ page }} of {{ maxPage }} [showing {{itemsPerPage}} of {{totalRows}}] </span>
				<router-link v-if="hasMore" :to="'/' + resource + '/' + (page + 1)">more &gt;</router-link>
				<a v-else class="disabled">more &gt;</a>
			</div>
		</div>
		<hr>
		<transition :name="transition">
			<div class="item-list" :key="displayedPage" v-if="displayedPage > 0">
				<transition-group tag="ul" name="item">
					<grid v-for="item in displayedItems.data" :key="item.id" :item="item">
					</grid>
				</transition-group>
			</div>
		</transition>
			</b-col>		
		</b-row>
	</b-container>
</template>

<script>

import { watchList } from '../api'
import Grid from '../components/Grid.vue'

export default {
	name: 'grid-table',

	components: {
		Grid
	},

	props: {
		resource: String
	},

	data () {
		return {
			currentPage: 1,
			useRouter: true,
			transition: 'slide-right',
			displayedPage: Number(this.$route.params.page) || 1,
			displayedItems: this.$store.getters.activeItems
		}
	},

	created() {
		// console.log(this);
		// this.page =Number(this.$route.params.page) || 1
	},

	computed: {
		page () {
			return Number(this.$route.params.page) || 1
		},
		totalRows(){
			const { lists } = this.$store.state
			return lists[this.resource].status.totalRecords
		},
		itemsPerPage(){
			return this.$store.state.itemsPerPage
		},
		maxPage () {
			const { itemsPerPage, lists } = this.$store.state
			// console.log('VVVVVVVVVVVVVVVV ',lists[this.resource].status.totalRecords/itemsPerPage);
			return Math.ceil(lists[this.resource].status.totalRecords/itemsPerPage) || 1
		},
		hasMore () {
			return this.page < this.maxPage
		}
	},

	beforeMount () {
		if (this.$root._isMounted) {
			this.loadItems(this.page)
		}
		// watch the current list for realtime updates
		this.unwatchList = watchList(this.resource, ids => {
			console.log('aaaaaaaaaaaaaaaaaaaaaaaa ----- ', this.resource);
			this.$store.commit('SET_LIST', { type: this.resource, ids })
			this.$store.dispatch('ENSURE_ACTIVE_ITEMS').then(() => {
				this.displayedItems = this.$store.getters.activeItems
			})
		})
	},

	beforeDestroy () {
		if (this.unwatchList){
			this.unwatchList()
		}
	},

	watch: {
		page (to, from) {
			this.loadItems(to, from)
		}
	},
	mounted(){
		this.$store.commit('ACTIVATE_ADMIN');
		this.$store.dispatch('CHECK')
			.then((checkOut) =>{
				// console.log('AAAAA : ',checkOut);
				this.data = checkOut.data;
			})
			.catch(err => {
				console.log(err);
			})
	},

	methods: {
		loadItems (to = this.page, from = -1) {
			console.log('Start loading items page : ', this.page)
			this.$bar.start()
			this.$store.dispatch('FETCH_RESOURCES_DATA', {
				resource: this.resource,
				params: {
					pageNumber: this.page,
				}
			}).then(() => {
				if (this.page < 0 || this.page > this.maxPage) {
					this.$router.replace(`/${this.resource}/1`)
					return
				}
				this.transition = from === -1
					? null
					: to > from ? 'slide-left' : 'slide-right'
				this.displayedPage = to
				this.displayedItems = this.$store.getters.activeItems
				this.$bar.finish()
			})
		}
	}
}
</script>

<style lang="stylus">

.item-list
	position absolute
	margin 0
	width 100%
	transition all .5s cubic-bezier(.55,0,.1,1)
	ul
		list-style-type none
		padding 0
		margin 0

.slide-left-enter, .slide-right-leave-to
	opacity 0
	transform translate(30px, 0)

.slide-left-leave-to, .slide-right-enter
	opacity 0
	transform translate(-30px, 0)

.item-move, .item-enter-active, .item-leave-active
	transition all .5s cubic-bezier(.55,0,.1,1)

.item-enter
	opacity 0
	transform translate(30px, 0)

.item-leave-active
	position absolute
	opacity 0
	transform translate(30px, 0)

@media (max-width 600px)
	.item-list
		margin 0
</style>



// WEBPACK FOOTER //
// GridContainer.vue